<template>
    <div class="rating-modal-overlay">
      <div class="rating-modal">
        <button class="close-btn" @click="$emit('close')">
          <i class="fa fa-times"></i>
        </button>
        <h2 class="modal-title">امتیاز شما به روبو</h2>
        <p class="modal-desc">از ۱ تا ۵ چه امتیازی به روبو می‌دهید؟</p>
        <div class="stars" dir="ltr">
          <span
            v-for="star in 5"
            :key="star"
            @click="selectStar(star)"
            @mouseover="hoverStar = star"
            @mouseleave="hoverStar = 0"
            :class="{ filled: userRating >= star || hoverStar >= star }"
          >★</span>
        </div>
        <!-- 1-3 stars: comment box and submit -->
        <transition name="fade">
          <div v-if="userRating > 0 && userRating < 4" class="feedback-section">
            <textarea
              v-model="userComment"
              placeholder="لطفا نظر خود را بنویسید..."
              class="feedback-input"
            ></textarea>
            <button
              class="submit-btn"
              @click="submitLowRating"
            >ثبت نظر</button>
          </div>
        </transition>
        <!-- 4-5 stars: thank you and go to market -->
        <transition name="fade">
          <div v-if="userRating >= 4" class="feedback-section">
            <button class="submit-btn" @click="goToMarket">ثبت نظر</button>
          </div>
        </transition>
        <button class="remind-btn" @click="remindMeLater">بعدا یادآوری کن</button>
      </div>
    </div>
  </template>
  
  <script>
  /* eslint-disable */
  import axios from "axios";
  import { notify } from "@kyvg/vue3-notification";
  export default {
    name: "RatingModal",
    data() {
      return {
        userRating: 0,
        userComment: "",
        hoverStar: 0,
        isApplication: navigator.userAgent.match(/ir.roboo.pwa/i) ? true : false,
      };
    },
    methods: {
      selectStar(star) {
        this.userRating = star;
      },
      submitLowRating() {
        axios
          .post("https://api.roboo.ir/api/Users/RateApp", {
            token: localStorage.getItem("token"),
            stars: this.userRating,
            comment: this.userComment,
          })
          .then(() => {
            localStorage.setItem("hasRated", "true");
            this.$emit("close");
            notify({
              title: "ممنون از بازخورد شما!",
              text: "نظر شما ثبت شد.",
              type: "success",
            });
          });
      },
      goToMarket() {
        localStorage.setItem("hasRated", "true");
        if(this.isApplication == true) {
          if (localStorage.getItem("campaign") == "myket") {
            Android.Download("myket://download/ir.roboo.pwa");
          } else if (localStorage.getItem("campaign") == "bazaar") {
            Android.Download("bazaar://details?id=ir.roboo.pwa");
          }
        }
        this.$emit("close");
      },
      remindMeLater() {
        let remindTime = Date.now() + 2 * 24 * 60 * 60 * 1000;
        localStorage.setItem("remindLaterTimestamp", remindTime.toString());
        this.$emit("close");
      },
    },
  };
  </script>
  
  <style scoped>
  .rating-modal-overlay {
    position: fixed;
    z-index: 20000;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(24, 24, 24, 0.92);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .rating-modal {
    background: rgb(30, 30, 30);
    border-radius: 18px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.35);
    padding: 36px 24px 28px 24px;
    width: 95vw;
    max-width: 380px;
    position: relative;
    text-align: center;
    color: #fff;
    font-family: IRANSansWeb, sans-serif;
    border: 1.5px solid #6153cc;
  }
  
  .close-btn {
    position: absolute;
    top: 14px;
    left: 14px;
    background: none;
    border: none;
    color: #fff;
    font-size: 1.4em;
    cursor: pointer;
    transition: color 0.2s;
  }
  .close-btn:hover {
    color: #6153cc;
  }
  
  .modal-title {
    font-size: 1.4em;
    font-weight: bold;
    color: #6153cc;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
  }
  
  .modal-desc {
    font-size: 1.05em;
    color: #eee;
    margin-bottom: 22px;
  }
  
  .stars {
    display: flex;
    justify-content: center;
    gap: 12px;
  }
  .stars span {
    font-size: 2.7em;
    cursor: pointer;
    color: #888;
    transition: color 0.2s, transform 0.15s;
    user-select: none;
    filter: drop-shadow(0 2px 8px #222);
  }
  .stars span.filled {
    color: #6153cc;
    text-shadow: 0 2px 8px #222;
    transform: scale(1.15);
  }
  .stars span:hover,
  .stars span.filled:hover {
    color: #4739b6;
    transform: scale(1.22);
  }
  
  .feedback-section {
    margin: 10px 0 10px 0;
    animation: fadeIn 0.3s;
  }
  
  .feedback-input {
    width: 100%;
    min-height: 70px;
    border-radius: 10px;
    border: none;
    padding: 12px;
    font-size: 1.05em;
    margin-bottom: 12px;
    resize: vertical;
    font-family: inherit;
    background: #2b2b2b;
    color: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
  
  .submit-btn {
    width: 100%;
    background: linear-gradient(90deg, #6153cc 60%, #7c6ee6 100%);
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 12px 0;
    font-size: 1.08em;
    font-weight: bold;
    cursor: pointer;
    margin-bottom: 8px;
    transition: background 0.2s, box-shadow 0.2s;
    box-shadow: 0 2px 8px rgba(97,83,204,0.12);
  }
  .submit-btn:disabled {
    background: #888;
    cursor: not-allowed;
  }
  
  .remind-btn {
    width: 100%;
    background: #6153cc;
    color: #ffffff;
    border: none;
    border-radius: 10px;
    padding: 10px 0;
    font-size: 1.05em;
    font-weight: bold;
    cursor: pointer;
    margin-top: 6px;
    transition: background 0.2s;
    box-shadow: 0 2px 8px rgba(253,216,83,0.10);
  }
  .remind-btn:hover {
    background: #6d61c5;
  }
  
  .thanks-message {
    color: #6153cc;
    font-weight: bold;
    margin-bottom: 14px;
    font-size: 1.15em;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  .thanks-message i {
    color: #ff6f91;
    font-size: 1.3em;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px);}
    to { opacity: 1; transform: none;}
  }
  </style>